import { render, staticRenderFns } from "./AddNotebook.vue?vue&type=template&id=81c09aca&scoped=true&"
import script from "./AddNotebook.vue?vue&type=script&lang=js&"
export * from "./AddNotebook.vue?vue&type=script&lang=js&"
import style0 from "./AddNotebook.vue?vue&type=style&index=0&id=81c09aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c09aca",
  null
  
)

export default component.exports